import { fontSizes } from 'styles/theme/typography'
import { radii } from 'styles/theme/shapings'

export type ButtonSize = 'small' | 'def'

type ButtonSizeProps = {
  minHeight: number // rem
  maxHeight: number // rem
  fontSize: string | number
  borderRadius: string | number
}

export const btnSizes: Record<ButtonSize, ButtonSizeProps> = {
  small: {
    minHeight: 2.25,
    maxHeight: 2.5,
    fontSize: fontSizes.default,
    borderRadius: radii.small,
  },
  def: {
    minHeight: 2.5,
    maxHeight: 2.75,
    fontSize: fontSizes.default,
    borderRadius: radii.small,
  },
}
